import {
  CLEAN_DOWNLOAD_PDF,
  CLEAN_DOWNLOAD_PDF_ERROR,
  DOWNLOAD_PDF,
  DOWNLOAD_PDF_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function downloadPdfReducer(state = initialState, action) {
  switch (action.type) {
    case DOWNLOAD_PDF:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_DOWNLOAD_PDF:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
